import { useCallback, useMemo } from 'react';
import { getAnalyticsService } from 'services/analyticsService';
import { getDiscoveryService } from 'services/discoveryService';

export function useShareToEmail() {
  const analyticsService = useMemo(() => getAnalyticsService(), []);
  const discoveryService = getDiscoveryService()!;
  const shareToEmail = useCallback(
    async (
      emailRecipients: string[],
      destinationName: string,
      queryParams: { [key: string]: string },
    ) => {
      analyticsService.track(analyticsService.events.ShareToEmail, {
        email: emailRecipients.join(','),
      });
      await discoveryService.shareToEmail(
        emailRecipients,
        destinationName,
        queryParams,
      );
    },
    [analyticsService, discoveryService],
  );

  return shareToEmail;
}
